module.exports = __webpack_public_path__ + "./fonts/PTSans-BoldItalic.ttf";